// extracted by mini-css-extract-plugin
export var wrapper = "Menu-module--wrapper--Q0F0A";
export var content = "Menu-module--content--mZDjB";
export var logo = "Menu-module--logo--T4Oyt";